<template>
	<v-container width="100%" ml-auto mr-auto pl-3 pr-0 pb-3 style="padding-top: 150px;">
		<v-flex mb-4>
			<v-btn @click="back">{{ translates["Вернуться"] }}</v-btn>
		</v-flex>

		<v-layout row wrap v-if='canRender'>
			<CardTemplate :data="parseData"/>
		</v-layout>

		<div class="custon-overlay" v-if="!canRender">
			<v-container absolute fluid fill-height justify-center>
				<v-progress-circular
					:size="120"
					:width="7"
					indeterminate
				></v-progress-circular>
			</v-container>
		</div>
	</v-container>
</template>

<script>
import axios from 'axios';
import CardTemplate from '../components/CardTemplate.vue';

export default {
	name: 'PersoneCard',

	data () {
		return {
			id: this.$router.currentRoute.params.id,
			lng: this.$store.getters.ACTIVE_LANGUAGE,
			canRender: false,
			pageData: {
				"id": 1,
				"date": "Дата создания",
				"birthday": "Дата рождения",
				"pnn": "РНН",
				"inn": "ИНН",
				"people": "Связанные лица (ID)",
				"company":[
					{
						"id": "Related company ID",
						"translate": {
							"ru": {
								"name": "Company name on ru lang"
							},
							"kaz": {
								"name": "Company name on kaz lang"
							}
						}
					}
				],
				"position_id": "Должность (ID)",
				"translate": {
					"ru": {
						"name": "Наименование",
						"position": "Наименование должности",
						"court": "Наименование суда"
					},
					"kaz": {
						"name": "Наименование",
						"position": "Наименование должности",
						"court": "Наименование суда"
					}
				},
				"img": 'https://images.pexels.com/photos/259803/pexels-photo-259803.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260'
			}
		}
	},

	components: {
		CardTemplate
	},

	created () {
		this.$api.get('personesShow', {
			params: {
				id: this.$router.currentRoute.params.id
			}
		}).then((resp) => {
			let respData = resp.data;

			this.pageData = respData.data;
			this.canRender = true;
		});
	},

  	computed: {
		translates () {
			return this.$store.getters.TRANSLATES;
		},

		parseData () {
			let parsedData = {};

			parsedData.list = [
				{
					name: 'ИД',
					value: this.pageData.id
				},
				{
					name: 'Дата создания',
					value: this.pageData.date
				},
				{
					name: 'Дата рождения',
					value: this.pageData.birthday
				},
				{
					name: 'РНН',
					value: this.pageData.pnn
				},
				{
					name: 'ИНН',
					value: this.pageData.inn
				},
				{
					name: 'Должность',
					value: this.pageData.translate[this.lng].position
				},
				{
					name: 'Суд',
					value: this.pageData.translate[this.lng].court
				}
			];

			parsedData.name = this.pageData.translate[this.lng].name;

			parsedData.img = 'https://images.pexels.com/photos/259803/pexels-photo-259803.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260';

			return parsedData;
		}
	},

	methods: {
		back () {
			this.$router.go(-1);
		}
	}
}
</script>

<style lang="scss">
</style>
